import React from 'react';

const Parceiros = () => {
  const partners = [
    // Linha 1
    {
      name: 'Bayer',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/0u3g4y2y_b.png',
      website: 'https://www.bayer.com.br/pt/'
    },
    {
      name: 'Ourofino',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/5ml20w9f_images%20%281%29.jpg',
      website: 'https://ourofinoagro.com.br/'
    },
    {
      name: 'Alta',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/dz94i345_logo-alta-e1741368702439.png',
      website: 'https://altadefensivos.com.br/'
    },
    {
      name: 'Nortox',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/zahaab4d_maior_nortox_1.png',
      website: 'https://www.nortox.com.br/'
    },
    {
      name: 'Helm',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/163ko8vq_Helm_%28Unternehmen%29_logo.svg.png',
      website: 'https://www.helmcrop.com.br/'
    },
    // Linha 2
    {
      name: 'Petrovina',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/fvfzu8rl_download.png',
      website: 'https://petrovinasementes.com.br/'
    },
    {
      name: 'Boa Safra',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/bmzs45d3_images%20%281%29.png',
      website: 'https://www.boasafrasementes.com.br/'
    },
    {
      name: 'ATTO',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/x0o6yqg6_logo_ATTO_Positiva.png',
      website: 'https://attosementes.com.br/'
    },
    {
      name: 'Tevo',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/88ffxxb5_tevo.png',
      website: 'https://www.tevosementes.com.br/'
    },
    {
      name: 'Santa Helena',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/9kate3p1_st.png',
      website: 'https://www.santahelenasementes.com.br/'
    },
    // Linha 3
    {
      name: 'Stoller',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/z9woylkh_s.png',
      website: 'https://www.stoller.com.br/'
    },
    {
      name: 'Rovensa Next',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/qcvt9mxy_rn.png',
      website: 'https://www.rovensanext.com.br/'
    },
    {
      name: 'Lallemand',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/4yyn50yt_l.png',
      website: 'https://www.lallemandplantcare.com/'
    },
    {
      name: 'Gênica',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/tqqz7mxo_Genica.png',
      website: 'https://www.genica.com.br/'
    },
    {
      name: 'Andermatt',
      logo: 'https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/0ahcv6u3_logo-17198214081.jpg',
      website: 'https://andermattdobrasil.com.br/'
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-r from-green-600 to-green-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-6xl font-bold mb-6">NOSSOS PARCEIROS</h1>
          <p className="text-2xl max-w-3xl mx-auto">
            Trabalhamos com as melhores marcas do mercado para oferecer produtos de qualidade
          </p>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {partners.map((partner, index) => (
              <a
                key={index}
                href={partner.website}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white border-2 border-gray-200 rounded-xl p-6 flex items-center justify-center hover:shadow-2xl hover:border-green-600 transition-all duration-300 transform hover:-translate-y-2 h-48 group"
              >
                <img 
                  src={partner.logo} 
                  alt={partner.name} 
                  className="max-h-32 max-w-full object-contain"
                />
              </a>
            ))}
          </div>

          <div className="mt-16 text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Trabalhamos com as Melhores Marcas</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Nossa parceria com as principais empresas do setor garante produtos de qualidade e tecnologia de ponta para sua lavoura.
            </p>
          </div>
        </div>
      </section>

      {/* Why Partners */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">Por que trabalhamos com os melhores?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-5xl mb-4 text-center">✅</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">Qualidade Garantida</h3>
              <p className="text-gray-600 text-center">
                Produtos testados e aprovados pelos principais produtores do Brasil
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-5xl mb-4 text-center">🔬</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">Tecnologia de Ponta</h3>
              <p className="text-gray-600 text-center">
                Inovações constantes para melhorar a produtividade da sua lavoura
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-5xl mb-4 text-center">🤝</div>
              <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">Suporte Técnico</h3>
              <p className="text-gray-600 text-center">
                Assistência especializada para você usar os produtos da melhor forma
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Parceiros;